/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IImplant } from 'app/shared/model/implant.model';
import { IHospitalProcedure } from 'app/shared/model/hospital-procedure.model';

export interface IProcedureImplant {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  quantity?: number;
  implant?: IImplant;
  procedure?: IHospitalProcedure;
}

export const defaultValue: Readonly<IProcedureImplant> = {
  active: false,
};
